<template>
  <b-modal id="addOlympiadModal"
           size="xl"
           centered
  >
    <template #modal-title>
      <h5>
        <em class="fas fa-plus send-icon mr-1"></em>Добавить новую олимпиаду
      </h5>
    </template>
    <template #default>
      <b-form-group label-for="year_input"
                    label-cols-sm="4"
                    label-cols-lg="3"
      >
        <template v-slot:label>
          Года проведения: <span class="text-danger">*</span>
        </template>
        <b-form-select id="year_input"
                       v-if="!isLoading"
                       :options="olympicsYears"
                       v-model="form.years"
                       required
        >
        </b-form-select>
      </b-form-group>
      <b-form-group label-for="year_input"
                    label-cols-sm="4"
                    label-cols-lg="3"
      >
        <template v-slot:label>
          Название: <span class="text-danger">*</span>
        </template>
        <b-form-input v-model="form.title"
                      maxlength="100"
                      type="text"
                      required
        >
        </b-form-input>
      </b-form-group>
        <ag-grid-vue
          class="ag-theme-material ag-grid-for-edit-stat"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :rowData="rowData"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @rowDataChanged = "onRowDataChanged"
          @column-resized="onColumnResized">
        </ag-grid-vue>
    </template>
    <template #modal-footer>
      <b-button cols="auto" @click="onSubmit"  variant="primary">
        <em class="fas fa-save"></em> Сохранить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import organizationApi from '@/api/organization'
import statisticsApi from '@/api/statistics'


export default {
  name: 'AddOlympiadModal',
  components: {
    AgGridVue
  },
  data() {
    return {
      selected: null,
      form: {
        title: '',
        years: ''
      },
      rowData: null,
      columnDefs: [
        {
          headerName: 'Класс',
          field: 'title',
          width: 170,
          minWidth: 170,
          editable: false,
          suppressSizeToFit: false
        },
        {
          headerName: 'Зарегистрировано в олимпиаде',
          field: 'registered',
          width: 180
        },
        {
          headerName: 'Участники заключительного этапа',
          field: 'membersOlymp',
          width: 180
        },
        {
          headerName: 'Призёры',
          field: 'semiwinners',
          width: 115
        },
        {
          headerName: 'Победители',
          field: 'winners',
          width: 140
        }
      ],
      gridApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true,
          sortable: true,
          editable: true,
          headerClass: 'table-olymp-stats-header',
          suppressSizeToFit: true,
          lockPosition: true
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 80,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      isLoading: true,
      olympicsYears: [],
      classMembers: []
    }
  },
  async beforeMount() {
    const academicYears = await statisticsApi.getAcademicYears()
    this.olympicsYears = academicYears.data.map(
      (olympicYear) => ({
        value: olympicYear.years.slice(0, 4),
        text: olympicYear.years
      }),
    )
    this.isLoading = false
    const classes = await organizationApi.getClasses()
    this.rowData = classes.data.map((org) => ({
      id: org.id,
      title: org.title,
      registered: 0,
      membersOlymp: 0,
      semiwinners: 0,
      winners: 0
    }))
    this.form.years = this.olympicsYears[0].value
  },

  methods: {
    ...mapActions({
      fetchStatsOlympicsResults: 'statistics/fetchStatsOlympicsResults',
      fetchGPClasses: 'content/fetchGPClassesForMap',
      fetchOlympics: 'dicts/fetchOlympics',
      pushToasts: 'toasts/pushToasts'
    }),
    onColumnResized() {
      this.gridApi.resetRowHeights()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    onRowDataChanged() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onSubmit() {
      if (this.form.title) {
        statisticsApi.addNewOlympiad(
          {
            description: this.form,
            data: this.rowData
          },
        ).then(({ data }) => {
          if (data !== -1) {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Создание олимпиады произошло успешно'
            })
            this.$parent.fetchStats(data)
            this.$bvModal.hide('addOlympiadModal')
          } else {
            this.pushToasts({
              title: 'Ошибка',
              error: true,
              message: 'Олимпиада с данным названием уже существует в системе!'
            })
          }
        }).catch((error) => {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'При создании олимпиады произошла ошибка'
          })
          console.log(error)
        })
      } else {
        this.pushToasts({
          title: 'Ошибка',
          error: true,
          message: 'Должны быть заполнены все поля!'
        })
      }
    }
  }
}
</script>

<style>
  .ag-grid-for-edit-stat {
    height: 500px;
    border-bottom: 1px solid #017ac3;
    border-top: 1px solid #017ac3;
  }
  .ag-grid-for-edit-stat .ag-header-cell-label .ag-header-cell-text {
    height: auto;
    white-space: normal;
    word-wrap: break-word;
    text-align: center;
  }
  .ag-grid-for-edit-stat .ag-icon {
    color: #017ac3;
  }

  .ag-grid-for-edit-stat .ag-header-viewport {
    border-bottom: 1px solid #017ac3;
  }
</style>
